'use client'

import PostalCodeContainer from 'pageContainers/PostalCodePage'
import FooterPortal from 'src/containers/Layouts/Layout/FooterPortal'
import { useAppSelector } from 'src/store/hooks'
import { isAppInitializedSelector } from 'store/modules/appConfig/selectors'

export default function SweepstakesCode() {
  const appInitialized = useAppSelector(isAppInitializedSelector)

  if (!appInitialized) {
    return null
  }

  return (
    <>
      <PostalCodeContainer />
      <FooterPortal />
    </>
  )
}
